<script>
import {ModalsContainer} from 'vue-final-modal'
import CartAPI from "$vueCommon/classes/API/CartAPI.js";
import CartItems from "./Cart/CartItems.vue";
import CartSummary from "./Cart/CartSummary.vue";
import bus from 'vue3-eventbus';
import CurrencyAPI from "../classes/API/CurrencyAPI.js";
import StickyElement from "$vueCommon/classes/StickyElement.js";
import frontendImgCartLoader from '$frontend/img/cart-loader.svg';
import frontendImgCartEmpty from '$frontend/img/cart-empty.svg';
import Toast from "$vueCommon/components/Toast.vue";
import CheckoutAPI from "$vueCommon/classes/API/CheckoutAPI.js";

export default {
    components: {
        Toast,
        CartSummary, CartItems, ModalsContainer
    },
    mounted() {
        if (typeof (manager) !== 'undefined') {
            CartAPI.setManagerBaseUrl();
            CheckoutAPI.setManagerBaseUrl();
            this.manager = true;
        }

        Promise.all([CartAPI.content(), CurrencyAPI.info()]).then(values => {
            this.items = values[0].cart_content || [];
            this.cartSummary = values[0].cart_summary;
            this.discountCode = values[0].discount_code;
            this.refreshCart({data: values[0]});
            this.ready = true;
        });

        bus.on('refreshCart', (event) => {
            this.refreshCart(event);
        });

        if (typeof (cartUrl) !== 'undefined') {
            this.cartUrl = cartUrl;
        }

        if (typeof (checkoutUrl) !== 'undefined') {
            this.checkoutUrl = checkoutUrl;
        }
    },
    updated() {
        StickyElement.create('.sticky-element')
    },
    methods: {
        refreshCart(event) {
            this.cartSummary = event.data.cart_summary;
            this.discountCode = event.data.discount_code;
            this.items = event.data.cart_content;
        }
    },
    data() {
        return {
            items: [],
            cartItemsSaving: {},
            discountCode: '',
            ready: false,
            cartUrl: '',
            checkoutUrl: '',
            manager: false,
            frontendImgCartLoader,
            frontendImgCartEmpty
        }
    },
    computed: {}
};
</script>
<template>
    <template v-if="!ready">
        <div class="container component-cart">
            <div class="text-center loader-container">
                <img :src="frontendImgCartLoader">
                <div class="h2">{{ $translate('checkout.loading_cart_data') }}</div>
            </div>
        </div>
    </template>
    <template v-if="ready && items.length === 0">
        <div class="container component-cart">
            <div class="cart-empty loader-container text-center">
                <div class="cart-empty"></div>
                <img :src="frontendImgCartEmpty">
                <div class="h2">{{ $translate('checkout.your_cart_is_empty') }}</div>
            </div>
        </div>
    </template>
    <template v-if="ready && items.length > 0">
        <div class="checkout-steps p-0 mt-4 mb-4 mb-md-6">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="steps">
                            <div class="step step-current">
                                <i class="fa fa-chevron-circle-right"></i> <a
                                :href="cartUrl">{{ $translate('checkout.cart') }}</a>
                            </div>
                            <div class="step step-waiting">
                                <i class="fa fa-chevron-circle-right"></i> {{ $translate('checkout.checkout') }}
                            </div>
                            <div class="step step-waiting">
                                <i class="fa fa-times-circle"></i> {{ $translate('checkout.complete') }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container component-cart">
            <div class="row">
                <div class="col-lg-8">
                    <CartItems
                        :items="items"
                        :source="'Cart'"
                        :saving="cartItemsSaving"
                    />
                </div>
                <div class="col-lg-4 position-relative">
                    <div class="sticky-element">
                        <CartSummary
                            :cartSummary="cartSummary"
                            :discountCode="discountCode"
                            :source="'Cart'"
                            :manager="manager"
                        />
                    </div>
                </div>
            </div>
        </div>
    </template>
    <ModalsContainer></ModalsContainer>
    <div class="vue-toasts">
        <Toast></Toast>
    </div>
</template>
